import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable, map, catchError, of 
} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HealthService {
  constructor(private http: HttpClient) {}

  private readonly healthURL = `${environment.teamSalaryBackendUrl}/health`;

  isHealthy(): Observable<{ healthy: boolean; message?: string }> {
    return this.http.get(this.healthURL).pipe(
      map(() => ({ healthy: true })),
      catchError((error) => {
        if (error?.status === 503) {
          const message = error?.error?.message
            || 'Undergoing scheduled maintenance. We will be back online shortly';
          return of({ healthy: false, message });
        }
        return of({ healthy: true });
      })
    );
  }
}
